<template>
  <a
    class="btn btn-sm single-share-button d-flex justify-content-center align-items-center"
    :title="$translate('modeherz::SocialMediaClient.socialMediaShare')"
    @click.prevent="shareViaApi"
  >
    {{ $translate('modeherz::SocialMediaClient.socialMediaShare') }}
    <icon
      icon="share-alt"
      class="default-float ml-3"
      :loading="isLoading"
    />
  </a>
</template>

<script>

export default {
    name: 'SingleShareButton',
    props: {
        variation: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            supportsShareApi: true,
            isLoading: false
        }
    },
    computed: {
        plainUrl () {
            return 'https://www.modeherz.de/' + this.variation.texts.urlPath + '_' + this.variation.item.id + '_' + this.variation.variation.id
        }
    },
    mounted () {
        this.supportsShareApi = !!navigator.share
    },
    methods: {
        async shareViaApi () {
            const shareData = {
                url: this.plainUrl
            }
            try {
                this.isLoading = true
                await navigator.share(shareData)
            } catch (err) {
                console.log('sharing url failed', err)
            } finally {
                this.isLoading = false
            }
        }
    }
}
</script>
